module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', {
    staticClass: "fa fa-store-alt"
  }, [_vm._v(" ")]), _c('org-badge'), _vm._v("Dashobard"), (!_vm.isTowerCo() && _vm.org().shortName) ? _c('small', {
    staticClass: "text-info pull-right hidden-sm-and-down"
  }, [_vm._v(_vm._s(_vm.org().name))]) : _vm._e()], 1), _vm._v(" "), _c('tenancy-due', {
    attrs: {
      "org-id": _vm.org().id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-663555af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/LandlordView.vue
// module id = 1610
// module chunks = 0